export const CourseStoreDetailSubject = ({className, content}) => {
    return (
        <div class={`px-[27px] py-[10px]  rounded-[36px] text-[28px] font-medium ${className}`}>
       {content}
        </div>
    );
};